<template>
  <ProgramSettingsFormWrapper
    :form-data="formData"
    :keys-to-reset="keysToReset"
    :disable-save.sync="disableSave"
    title="Wellness Metrics/Challenges Settings"
  >
    <WtTile parent vertical :col="12">
      <WtSwitchQuestionInput
        v-model="isWellnessMetricsOn"
        label="Enable Wellness Metrics/Challenges"
        :tooltip-text="isWellnessMetricOnTooltip"
        @input="disableSave = false"
      />
    </WtTile>
  </ProgramSettingsFormWrapper>
</template>

<script>
import WtTile from "@@/WtTile/WtTile.vue";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput.vue";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper.vue";
import { mapActions, mapGetters } from "vuex";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";

export default {
  name: "WellnessMetricsFeatureSettings",

  components: {
    WtTile,
    WtSwitchQuestionInput,
    ProgramSettingsFormWrapper
  },

  mixins: [programSettingsFormMixin],

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    isWellnessMetricOnTooltip() {
      return `Enable the Wellness Metrics/Challenges feature for your program.`;
    },

    formData() {
      return {
        isWellnessMetricsOn: this.isWellnessMetricsOn
      };
    },

    keysToReset() {
      return ["isWellnessMetricsOn"];
    },

    isWellnessMetricsOn: {
      set(isWellnessMetricsOn) {
        this.updateProgramSettingsCopy({
          key: "isWellnessMetricsOn",
          value: isWellnessMetricsOn
        });
      },
      get() {
        return this.programSettingsCopy.isWellnessMetricsOn ? 1 : 0;
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>
